import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Table } from "../Table/Table";
import moment from "moment";
import { checkPermission } from "../../screen/redux/api/PermissionManager";

const FailedOwner = ({
  ownersList,
  pagination,
  reSend,
  handlerPopup,
  setIsViewIdFalied,
  setPagination,
  // deleteCoupon={deleteRoom}
  page,
  handlerRepay,
  setPage,
}) => {
  const inputRef = useRef(null);
  const navigate = useNavigate();
  // const [page, setPage] = useState(1);

  const [owners, setOwners] = useState(ownersList);
  useEffect(() => {
    setOwners(ownersList);
  }, [ownersList]);
  console.log("ownersList", ownersList);
  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="red">{(page - 1) * 10 + (row.index + 1)}</p>;
        },
      },
      {
        Header: "Created By",
        accessor: "owner_name",
        Cell: ({ value, row }) => {
          const property = row.original;
          console.log("DASDL", property);
          return (
            <>
              <p className="text-nowrap">{value ? `${value} ` : "-"}</p>
              <p style={{ fontSize: 12, color: "#adadad" }}>
                {row.original?.created_at
                  ? `${moment(row.original?.created_at).format(
                      "DD-MM-YYYY hh:mm A"
                    )}`
                  : ""}
              </p>
            </>
          );
        },
      },
      {
        Header: "Amount",
        accessor: "amount",
        Cell: ({ value, row }) => {
          return (
            <>
              <p className="text-nowrap">{value ? `${value} ` : "-"}</p>{" "}
            </>
          );
        },
      },

      {
        Header: "Status",
        accessor: "admin_wallet_status",
        Cell: ({ value, row }) => {
          return (
            <div
              style={{ background: "#F52E2E", borderRadius: 10, width: 154 }}
            >
              <p
                style={{
                  color: "#fff",
                  margin: 0,
                  textAlign: "center",
                  paddingLeft: 10,
                  paddingRight: 10,
                  paddingTop: 5,
                  paddingBottom: 5,
                }}
              >
                Failed
              </p>
            </div>
          );
        },
      },
    ];
    let action = {
      Header: "Description",
      accessor: "",
      Cell: ({ row }) => {
        const item = row.original;

        return (
          <div
            style={{
              display: "flex",
              gap: 10,
            }}
          >
            {/* Add Button */}
            <div
              onClick={() => {
                handlerPopup(true);
                setIsViewIdFalied(item);
              }}
              style={{
                background: "#9A36E6",
                borderRadius: 10,
                width: 85,
                cursor: "pointer",
              }}
            >
              <p
                style={{
                  color: "#fff",
                  margin: 0,
                  textAlign: "center",
                  padding: "5px 10px",
                }}
              >
                Add
              </p>
            </div>

            {/* RePay Button */}
            <div
              onClick={() => handlerRepay(item)}
              style={{
                background: "gray",
                borderRadius: 10,
                width: 85,
                cursor: "pointer",
              }}
            >
              <p
                style={{
                  color: "#fff",
                  margin: 0,
                  textAlign: "center",
                  padding: "5px 10px",
                }}
              >
                RePay
              </p>
            </div>
          </div>
        );
      },
    };
    return checkPermission("CAN-EDIT-WALLETOWNER") ? [...d, action] : d;
  }, [page]);

  return (
    <div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={owners}
        show={true}
      />
    </div>
  );
};

export default FailedOwner;
